import { Co2Section } from '@/domain/impact-co2/entities/question.entity';
import { Co2QuizFormData } from '@/ui/pages/app/components/quiz-panel/co2/Co2QuizFormData';

export function getTourCo2QuizFormData(
  section: string,
): Co2QuizFormData | undefined {
  switch (section) {
    case 'CREATION':
      return creationForm;
    case 'MANAGEMENT':
      return managementForm;
    case 'COMMUNICATION':
      return communicationForm;
    default:
      return undefined;
  }
}

const creationForm: Co2QuizFormData = {
  sector: 'TEAM',
  sections: [
    {
      sectionKey: Co2Section.SCENOGRAPHY,
      questions: ['SCENOGRAPHY_NO_RECYCLABLE', 'SCENOGRAPHY_RECYCLABLE'],
    },
    {
      sectionKey: Co2Section.MOBILITY, // ProjectsTour.GeneralCo2Quiz.Categories.TEAM_MOBILITY
      questions: ['TEAM_MOBILITY'],
    },
    {
      sectionKey: Co2Section.ACCOMMODATION, // ProjectsTour.GeneralCo2Quiz.Categories.REPEATS_AND_MATERIAL
      questions: ['BUILDING_HEATING', 'EQUIPMENT', 'CARGO'],
    },
  ],
};

const managementForm: Co2QuizFormData = {
  sector: 'SITE',
  sections: [
    {
      sectionKey: Co2Section.ACCOMMODATION, // ProjectsTour.GeneralCo2Quiz.Categories.TEAM_MOBILITY
      questions: ['TEAM_MOBILITY'],
    },
    {
      sectionKey: Co2Section.CATERING,
      questions: ['CATERING_MEAL'],
    },
    {
      sectionKey: Co2Section.BUILDING, // ProjectsTour.GeneralCo2Quiz.Categories.OFFICE
      questions: [
        'OFFICE_SUPPLIES_NEW',
        'OFFICE_SUPPLIES_REFURBISH',
        'BUILDING_HEATING',
      ],
    },
  ],
};

const communicationForm: Co2QuizFormData = {
  sector: 'PUBLIC',
  sections: [
    {
      sectionKey: Co2Section.DIGITAL, // ProjectsTour.GeneralCo2Quiz.Categories.VIDEO_AND_DIGITAL
      questions: ['DIGITAL'],
    },
  ],
};
